module.exports = __webpack_public_path__ + "static/media/ISO9001.4f22c478.png";